// extracted by mini-css-extract-plugin
export default {"container":"PageLayout_container__E6BHO","body":"PageLayout_body__pORo9"};